module.exports = __webpack_public_path__ + "static/media/footer-phone.28328255.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-phone.png
// module id = 1374
// module chunks = 42